// extracted by mini-css-extract-plugin
export default {"inputLabel":"inputLabel-zq4iw","row":"row-f2oqm","body":"body-r2drM"};